import React from 'react'

export const Download = () => {
  return (
    <div>Download</div>
  )
}
